module.exports = {
	"data": {
		"0C00000AR3": [
			"CoreCivic",
			"The world's largest private prison corporation. Owns and manages over 100 correctional, detention, and other residential reentry facilities. Provides the government with other services as part of the criminal punishment system.",
			"Community Corrections, E-Carceration, Facility Construction and Maintenance, Facility Management, Prison Labor, Transportation and Deportations, Youth and Family Detention Facilities",
			"https://investigate.info/company/corecivic",
			1,
			1,
			1,
			1
		],
		"0C00000CMK": [
			"GEO Group",
			"The world's 2nd largest private prison company and the largest \"community corrections\" and e-carceration business. Owns and operates prisons and immigrant detention centers in the US and abroad. Provides the government with other services as part of the criminal punishment system.",
			"Community Corrections, E-Carceration, Facility Construction and Maintenance, Facility Management, Private Facilities Internationally, Prison Labor, Transportation and Deportations, Youth and Family Detention Facilities",
			"https://investigate.info/company/geo-group",
			1,
			1,
			1,
			1
		],
		"0C00000N0R": [
			"MITIE Gr",
			"A British facility management, consultancy, and product management company that operates private prisons and immigration detention centers in the UK.",
			"Private Facilities Internationally",
			"https://investigate.info/company/mitie-group",
			1,
			0,
			1,
			1
		],
		"0C00000MVT": [
			"Serco Group",
			"A British multinational outsourcing company that operates prisons and immigration jails in the UK, Australia, and New Zealand.",
			"Private Facilities Internationally",
			"https://investigate.info/company/serco-group",
			1,
			0,
			1,
			1
		],
		"0C0000093N": [
			"Sodexo",
			"A French multinational food services and facilities management company. Operates prisons in Australia and the UK.",
			"Private Facilities Internationally",
			"https://investigate.info/company/sodexo",
			1,
			0,
			1,
			1
		],
		"0C000090UD": [
			"Acadia Healthcare Co",
			"A US healthcare company. Provides community corrections including residential re-entry programs. Has detained small numbers of unaccompanied immigrant youth.",
			"Community Corrections",
			"https://investigate.info/acadia-healthcare",
			1,
			1,
			1,
			0
		],
		"0C00000971": [
			"Air Transport Services Gr",
			"A US air cargo and transportation company, which operates charter deportation flights for the US government.",
			"Transportation and Deportations",
			"https://investigate.info/company/atsg",
			1,
			1,
			1,
			0
		],
		"0C00000UK2": [
			"Airbus",
			"A Dutch multinational military and aerospace company whose helicopters are used to monitor the US-Mexico border.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/airbus",
			0,
			1,
			1,
			0
		],
		"0C00008Q4W": [
			"Aramark",
			"A US-based provider of food service, facility management services, and uniforms globally. Provides food and other logistical services to prisons and immigration detention facilities and uses forced prison labor.",
			"Food Commissary and Other Goods, Prison Labor",
			"https://investigate.info/company/aramark",
			1,
			1,
			1,
			0
		],
		"0C00000CJ1": [
			"Axon Enterprise",
			"A US manufacturer of tasers, body and car cameras, drones, and accompanying software that provides these products to US immigration authorities, prisons, and law enforcement agencies.",
			"Border Surveillance and Monitoring, Facility Surveillance and Security",
			"https://investigate.info/company/axon-enterprise",
			1,
			1,
			1,
			0
		],
		"0C00004322": [
			"Booz Allen Hamilton",
			"A US government IT contractor, which developed cloud analytics services for US immigration authorities to track and target immigrants.",
			"High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/booz-allen-hamilton",
			0,
			1,
			1,
			0
		],
		"0C0000C7HA": [
			"Cadre Hldgs",
			"The owner of Safariland and Defense Technology, the largest US manufacturer of tear gas weapons for law enforcement. Its chemical and other crowd-control weapons are used by US border patrol, prison authorities, and police departments across the US and around the world against civilian protesters.",
			"Border Surveillance and Monitoring, Facility Surveillance and Security",
			"https://investigate.info/company/cadre-holdings",
			1,
			1,
			1,
			0
		],
		"0C0000917Y": [
			"Carlyle Group",
			"A US-based global investment firm. Its subsidiary Mantech is a military contractor that provides IT and surveillance services to US immigration authorities.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/mantech-international",
			0,
			1,
			1,
			0
		],
		"0C0000C815": [
			"Cellebrite DI",
			"An Israeli digital intelligence firm that supplies law enforcement agencies, prison authorities, border security agencies, and repressive regimes around the world with hacking technologies.",
			"Border Surveillance and Monitoring, Facility Surveillance and Security, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/cellebrite",
			1,
			1,
			1,
			0
		],
		"0C00002EQZ": [
			"Citizens Financial Group",
			"A US-based financial services and bank holding company. Its subsidiary Citizens Bank has provided credit and loans to private prison corporation CoreCivic.",
			"Private Prison Financing",
			"https://investigate.info/company/citizens-financial-group",
			1,
			1,
			1,
			0
		],
		"0C0000BVDB": [
			"Colt CZ Group",
			"A manufacturer of firearms and ammunition for military, law enforcement, and commercial markets in the U.S. and around the world.",
			"Border Surveillance and Monitoring, Facility Surveillance and Security",
			"https://investigate.info/company/colt-cz-group",
			1,
			1,
			1,
			0
		],
		"0C00000B4B": [
			"Elbit Systems",
			"Israel's largest military company, which makes killer drones, large weapon systems, and ammunition used against civilians. Monitors walls and borders along the US-Mexico border.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/elbit-systems",
			0,
			1,
			1,
			0
		],
		"0C000007NL": [
			"First Horizon",
			"A US-based financial services and bank holding company. Its subsidiary First Horizon Bank has provided credit and loans to private prison corporation CoreCivic.",
			"Private Prison Financing",
			"https://investigate.info/company/first-horizon",
			1,
			1,
			1,
			0
		],
		"0C000007TZ": [
			"General Dynamics",
			"One of the largest military contractors in the world. Involved in monitoring the US-Mexico border and surveilling immigrant communities inside the US.",
			"Border Surveillance and Monitoring, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/general-dynamics",
			0,
			1,
			1,
			0
		],
		"0C00000B4D": [
			"Granite Construction",
			"A US construction company that constructed parts of and performed maintenance on the US-Mexico border barrier.",
			"Border Construction and Maintenance",
			"https://investigate.info/company/granite-construction",
			0,
			1,
			1,
			0
		],
		"0C00000BC7": [
			"HSBC Holdings",
			"A UK-based financial services and bank holding company. Its subsidiary banks have provided credit and loans to private prison corporation GEO Group.",
			"Private Prison Financing",
			"https://investigate.info/company/hsbc-holdings",
			1,
			1,
			1,
			0
		],
		"0C00000L4T": [
			"KBR",
			"A US engineering and construction firm that does maintenance and repairs of the US-Mexico border fence in Arizona.",
			"Border Construction and Maintenance",
			"https://investigate.info/company/kbr",
			0,
			1,
			1,
			0
		],
		"0C00000B7K": [
			"L3Harris Technologies",
			"A US-based military company that provides phone tracking devices and other equipment to US immigration authorities. Used to provide surveillance technologies for the US-Mexico border.",
			"High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/l3harris-technologies",
			0,
			1,
			1,
			0
		],
		"0C00000L0C": [
			"Leidos Holdings",
			"A US military IT contractor that provides imaging technologies and biometric systems to US immigration authorities for border monitoring and surveillance.",
			"Border Surveillance and Monitoring, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/leidos-holdings",
			0,
			1,
			1,
			0
		],
		"0C0000084Y": [
			"Lockheed Martin",
			"The world's largest military company that provides reconnaissance aircraft used to monitor the US-Mexico border.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/lockheed-martin",
			0,
			1,
			1,
			0
		],
		"0C000008HL": [
			"Motorola Solns",
			"A US-based communications and surveillance company. Leading supplier of license plate recognition software. Sells surveillance products for use at US prisons, at the US-Mexico Border, and by US police agencies.",
			"Border Surveillance and Monitoring, Facility Surveillance and Security, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/motorola-solutions",
			1,
			1,
			1,
			0
		],
		"0C00000BU6": [
			"NICE",
			"An Israeli surveillance company, specializing in phone, video, and internet monitoring. Its audio and video indexing and mining software Nexidia is used by US prisons.",
			"Facility Surveillance and Security",
			"https://investigate.info/company/nice",
			1,
			0,
			1,
			0
		],
		"0C00000BVX": [
			"Northrop Grumman",
			"One of the world's largest military companies. Provides drones and radars used to monitor the US-Mexico border, and develops databases and systems for the US Department of Homeland Security to profile, surveil, and monitor immigrant communities.",
			"Border Surveillance and Monitoring, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/northrop-grumman",
			0,
			1,
			1,
			0
		],
		"0C0000AA2O": [
			"Palantir Technologies",
			"A US-based high-tech surveillance company. Designed systems for US immigration authorities to surveil and target immigrants and to manage mass immigration raids. Its predictive policing tools are used by law enforcement agencies.",
			"High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/palantir",
			0,
			1,
			1,
			0
		],
		"0C00000C90": [
			"Pinnacle Finl Partners",
			"A US-based financial services and bank holding company. Its subsidiary Pinnacle Bank has provided credit and loans to private prison corporation CoreCivic.",
			"Private Prison Financing",
			"https://investigate.info/company/pinnacle-finl-partners",
			1,
			1,
			1,
			0
		],
		"0C00000CUU": [
			"RTX",
			"One of the largest military companies in the world and the largest producer of guided missiles. Its equipment is used to monitor the US-Mexico border.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/rtx",
			0,
			1,
			1,
			0
		],
		"0C000008R8": [
			"Regions Finl",
			"A US-based financial services and bank holding company. Its subsidiary Regions Bank has provided credit and loans to private prison corporations CoreCivic and GEO Group.",
			"Private Prison Financing",
			"https://investigate.info/company/regions-financial",
			1,
			1,
			1,
			0
		],
		"0C000027WA": [
			"Science Applications Intl",
			"A US military and intelligence contractor, which has enhanced data sharing between US immigration authorities and local law enforcement agencies.",
			"High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/saic",
			0,
			1,
			1,
			0
		],
		"0C00000CF7": [
			"Sturm Ruger & Co",
			"A US manufacturer of firearms and tactical gear. It sells its products to law enforcement, the US military, and foreign militaries.",
			"Facility Surveillance and Security",
			"https://investigate.info/company/sturm-ruger-co",
			1,
			0,
			1,
			0
		],
		"0C00002DE7": [
			"Sun",
			"A majority owner of Cellebrite, an Israeli digital intelligence firm that supplies law enforcement agencies, prison authorities, border security agencies, and repressive regimes around the world with hacking technologies.",
			"Border Surveillance and Monitoring, Facility Surveillance and Security, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/cellebrite",
			1,
			1,
			1,
			0
		],
		"0C00000X87": [
			"SuperCom",
			"An Israeli company specializing in electronic monitoring, digital ID technologies, and cyber security. It owns California-based Leaders in Community Alternatives (LCA), an electronic monitoring and \"community corrections\" company.",
			"Community Corrections, E-Carceration",
			"https://investigate.info/company/supercom",
			1,
			0,
			1,
			0
		],
		"0C00000CHY": [
			"Synovus Finl",
			"A US-based financial services and bank holding company. Its subsidiary Synovus Bank has provided credit and loans to private prison corporation CoreCivic.",
			"Private Prison Financing",
			"https://investigate.info/company/synovus-finl",
			1,
			1,
			1,
			0
		],
		"0C0000BDQI": [
			"Target Hospitality",
			"A US workforce housing company that owns and partially operates ICE's largest youth and family detention center.",
			"Facility Construction and Maintenance, Facility Management, Food Commissary and Other Goods, Youth and Family Detention Facilities",
			"https://investigate.info/company/target-hospitality",
			1,
			1,
			1,
			0
		],
		"0C00000CKK": [
			"Teledyne Technologies",
			"A US engineering and IT government contractor. Its subsidiary FLIR Systems provides mobile surveillance systems to monitor the US-Mexico border.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/teledyne-technologies",
			0,
			1,
			1,
			0
		],
		"0C00000CME": [
			"Textron",
			"A US-based military contractor known for its Bell, Beechcraft, Cessna, and Hawker aircraft brands, some of which are used to monitor the US-Mexico border.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/textron",
			0,
			1,
			1,
			0
		],
		"0C00000CN4": [
			"Thomson Reuters",
			"A Canadian data broker and information services provider that provides systems and databases to the US immigration authorities for tracking and targeting immigrant communities.",
			"High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/thomson-reuters",
			0,
			1,
			1,
			0
		],
		"0C0000CAEZ": [
			"Ventia Services Group",
			"An Australian infrastructure company whose subsidiary Broadspectrum operates a private prison in Australia.",
			"Private Facilities Internationally",
			"https://investigate.info/company/Ventia",
			1,
			0,
			1,
			0
		],
		"0C0000095Q": [
			"3M",
			"3M Company is a conglomerate corporation operating in the manufacturing, health care, and consumer goods industries. Supplies materials for prison labor programs.",
			"Prison Labor",
			"https://investigate.info/company/3m",
			1,
			0,
			0,
			0
		],
		"0C00000AGU": [
			"AT&T",
			"A US telecommunications company that provides communications services to US immigration authorities.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/att",
			0,
			1,
			0,
			0
		],
		"0C0000097A": [
			"Accenture",
			"An Irish management, consulting, and outsourcing firm that provides technical and planning support to US Customs and Border Protection (CBP).",
			"Border Surveillance and Monitoring, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/accenture",
			0,
			1,
			0,
			0
		],
		"0C00000PB1": [
			"AeroVironment",
			"A military contractor that makes small drones used to surveil the US-Mexico border.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/aerovironment",
			0,
			1,
			0,
			0
		],
		"0C000007XQ": [
			"Alphabet",
			"One of the world's largest IT companies. Its subsidiary Google provides software and cloud services to US immigration authorities.",
			"Border Surveillance and Monitoring, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/alphabet",
			0,
			1,
			0,
			0
		],
		"0C000009EB": [
			"Amazon.com",
			"The world's largest online retailer and cloud storage provider. It's the largest provider of cloud computing for US immigration authorities, and also supports prison and police surveillance.",
			"Facility Surveillance and Security, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/amazon",
			1,
			1,
			0,
			0
		],
		"0C00000AEB": [
			"Archer-Daniels Midland",
			"A US multinational company that manufactures food for humans, pets, and livestock. It purchases raw goods from prison farms.",
			"Prison Labor",
			"https://investigate.info/company/adm",
			1,
			0,
			0,
			0
		],
		"0C00000AJ4": [
			"Aware",
			"A software company that provides US immigration authorities with software that collects and manages biometric data.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/aware",
			0,
			1,
			0,
			0
		],
		"0C000006W2": [
			"Benchmark Electronics",
			"A US-based producer of high-end computing and industrial products that provides Mobile Video Surveillance Systems (MVSS) for monitoring the US-Mexico border.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/benchmark-electronics",
			0,
			1,
			0,
			0
		],
		"0C000006WA": [
			"Berkshire Hathaway",
			"A US-based conglomerate holding company and investment firm. Its subsidiary Shaw Industries uses prison labor. Other subsidiaries provide equipment, utilities, and uniforms to prisons and jails.",
			"Food Commissary and Other Goods, Prison Labor",
			"https://investigate.info/company/berkshire-hathaway",
			1,
			0,
			0,
			0
		],
		"0C0000072U": [
			"CACI International",
			"A government contractor that provides computer and IT services to US immigration authorities and other federal agencies.",
			"Border Surveillance and Monitoring, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/caci-international",
			0,
			1,
			0,
			0
		],
		"0C0000073O": [
			"Cal-Maine Foods",
			"The largest egg producer in the US. It uses prison labor.",
			"Prison Labor",
			"https://investigate.info/company/cal-maine-foods",
			1,
			0,
			0,
			0
		],
		"0C00000VZZ": [
			"Capgemini",
			"A French IT and engineering firm, which helps US immigration authorities optimize their incarceration and deportations.",
			"High-Tech Surveillance of Immigrants, Transportation and Deportations",
			"https://investigate.info/company/capgemini",
			1,
			1,
			0,
			0
		],
		"0C0000075R": [
			"Cardinal Health",
			"A medical supply company that provides pharmaceuticals to prisons, including for executions. Its subsidiary Tradex provides materials for use in prison labor programs.\n",
			"Health Services, Prison Labor",
			"https://investigate.info/company/cardinal-health",
			1,
			0,
			0,
			0
		],
		"0C00000EJ8": [
			"Cemtrex",
			"A US-based producer of surveillance tools that provides video management systems for monitoring prisons, jails, and the US-Mexico border.",
			"Border Surveillance and Monitoring, Facility Surveillance and Security, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/cemtrex",
			1,
			1,
			0,
			0
		],
		"0C00000X07": [
			"Chocoladefabriken",
			"A Swiss chocolate and confectionery company. Its American subsidiary Russell Stover uses prison labor.",
			"Prison Labor",
			"https://investigate.info/company/lindt",
			1,
			0,
			0,
			0
		],
		"0C00000ARG": [
			"Costco Wholesale",
			"One of the largest retailers in the US. Has prison labor in its supply chain.",
			"Prison Labor",
			"https://investigate.info/company/costco-wholesale",
			1,
			0,
			0,
			0
		],
		"0C00000AWI": [
			"Deere",
			"A US-based manufacturer of agricultural and construction machinery, which provides all-terrain vehicles to US Border Patrol.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/deere",
			0,
			1,
			0,
			0
		],
		"0C000009MT": [
			"Elevance Health",
			"A US health insurer that provides health services to youth jails and criminal legal programs.",
			"Health Services",
			"https://investigate.info/company/anthem",
			1,
			0,
			0,
			0
		],
		"0C000007HU": [
			"Equifax",
			"A US-based credit reporting agency and data broker that provides US immigration authorities with information that enables them to locate people targeted for deportation.",
			"High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/equifax",
			0,
			1,
			0,
			0
		],
		"0C000007KA": [
			"Fairfax Finl Hldgs",
			"A Canadian investment and insurance company. One of the largest U.S. bail bond insurers.",
			"Bail Bonds",
			"https://investigate.info/company/fairfax-financial-holdings",
			1,
			0,
			0,
			0
		],
		"0C000007QC": [
			"Ford Motor",
			"A US-based vehicle manufacturer that provides commercial and specialized vehicles to US law enforcement and immigration authorities.",
			"Border Surveillance and Monitoring, Prison Labor, Transportation and Deportations",
			"https://investigate.info/company/ford-motor",
			1,
			1,
			0,
			0
		],
		"0C00006B5P": [
			"General Motors",
			"A US-based vehicle manufacturer that provides commercial and specialized vehicles to law enforcement and immigration authorities.",
			"Border Surveillance and Monitoring, High-Tech Surveillance of Immigrants, Transportation and Deportations",
			"https://investigate.info/company/general-motors",
			1,
			1,
			0,
			0
		],
		"0C00000BBI": [
			"Honda Motor Co",
			"A Japanese vehicle manufacturer, which provides US Border Patrol with all-terrain vehicles.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/honda-motor-co",
			0,
			1,
			0,
			0
		],
		"0C00000BDL": [
			"IBM",
			"One of the world's largest IT companies. A major contractor for U.S. immigration authorities.",
			"Border Surveillance and Monitoring, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/ibm",
			0,
			1,
			0,
			0
		],
		"0C00000802": [
			"Kroger",
			"A US retail company that operates supermarkets across the country. It sells products that are produced using prison labor.",
			"Prison Labor",
			"https://investigate.info/company/kroger",
			1,
			0,
			0,
			0
		],
		"0C000008A4": [
			"McDonald's",
			"The world's largest fast-food chain. It uses incarcerated labor at its restaurants and has prison labor in its supply chain.",
			"Prison Labor",
			"https://investigate.info/company/mcdonalds",
			1,
			0,
			0,
			0
		],
		"0C000037PX": [
			"Micro Systemation",
			"A Swedish data extraction firm that provides digital forensics tools to law enforcement and immigration authorities.",
			"Border Surveillance and Monitoring, E-Carceration, Facility Surveillance and Security, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/msab",
			1,
			1,
			0,
			0
		],
		"0C000008EC": [
			"Microsoft",
			"One of the world's largest IT companies. Provides tools and infrastructure used by the US government to surveil immigrant communities and to manage prisons.",
			"Facility Surveillance and Security, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/microsoft",
			1,
			1,
			0,
			0
		],
		"0C000008MH": [
			"ModivCare",
			"A US healthcare corporation, formerly known as Providence Service, that provides medical transportation to prisons.",
			"Health Services",
			"https://investigate.info/company/providence-service",
			1,
			0,
			0,
			0
		],
		"0C00000BR3": [
			"NEC",
			"A Japanese IT company that provides the US government with biometric technologies used to target immigrant communities.",
			"High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/nec",
			0,
			1,
			0,
			0
		],
		"0C00000C1W": [
			"OSI Systems",
			"A US manufacturer of security and inspection systems, which it provides to US border checkpoints.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/osi-systems",
			0,
			1,
			0,
			0
		],
		"0C00000CAD": [
			"Polaris",
			"A US vehicle manufacturer that provides all-terrain vehicles, utility task vehicles, and snowmobiles to immigration authorities.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/polaris",
			0,
			1,
			0,
			0
		],
		"0C000008QT": [
			"RELX",
			"A UK-based information and analytics firm. Its subsidiary LexisNexis provides data analytics to US immigration authorities to identify and locate persons targeted for deportation.",
			"High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/relx",
			0,
			1,
			0,
			0
		],
		"0C000008TK": [
			"RLI",
			"A US specialty insurance company. Has provided surety bonds to bail bond company Libre by Nexus.",
			"Bail Bonds",
			"https://investigate.info/company/rli-corp",
			1,
			1,
			0,
			0
		],
		"0C0000ASGH": [
			"Restaurant Brands Intl",
			"One of the world's largest fast-food restaurant companies. It uses prison labor at its restaurants and has prison labor in its supply chain.",
			"Prison Labor",
			"https://investigate.info/company/rbi",
			1,
			0,
			0,
			0
		],
		"0C000008W0": [
			"Salesforce",
			"A US cloud computing and AI company whose systems power the US Unified Immigration Portal.",
			"Border Surveillance and Monitoring, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/salesforce",
			0,
			1,
			0,
			0
		],
		"0C000008ZD": [
			"Semtech",
			"A US-based manufacturer of semiconductor, computing network, and connectivity products. Its Canadian subsidiary, Sierra Wireless, owns Numerex, which manufactures electronic monitoring and surveillance tools used to locate and track individuals for pretrial adjudication, probation, parole, and immigration control.",
			"E-Carceration",
			"https://investigate.info/company/sierra-wireless",
			1,
			0,
			0,
			0
		],
		"0C00000GNG": [
			"Smiths Group",
			"A British engineering company that provides X-ray and surveillance technologies to US immigration authorities to monitor borders.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/smiths-group",
			0,
			1,
			0,
			0
		],
		"0C00000CIT": [
			"Target",
			"A US retail company that sells household items, apparel, home furnishings, and other merchandise. It sells products that are produced using prison labor.",
			"Prison Labor",
			"https://investigate.info/company/target",
			1,
			0,
			0,
			0
		],
		"0C00000VIJ": [
			"Thales",
			"A French multinational that designs and manufactures electrical systems for the aerospace and defense industries. Supplies biometric technologies for the databases used to surveil immigrants in the US.",
			"High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/gemalto",
			0,
			1,
			0,
			0
		],
		"0C00000CMT": [
			"Thermo Fisher Scientific",
			"A US pharmaceutical and biotech company that provides equipment for mass DNA testing of people detained by US immigration authorities and Rapid DNA testing of migrant families at the US-Mexico border.",
			"Border Surveillance and Monitoring, High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/thermo-fisher-scientific",
			0,
			1,
			0,
			0
		],
		"0C00000GGQ": [
			"Track Group",
			"A US electronic monitoring technologies and equipment company. Provides law enforcement agencies with tracking and surveillance equipment for people on probation or parole.",
			"E-Carceration",
			"https://investigate.info/company/track-group",
			1,
			0,
			0,
			0
		],
		"0C0000AW3T": [
			"TransUnion",
			"A credit rating agency and data broker that provides customized software and services to law enforcement and US immigration authorities.",
			"High-Tech Surveillance of Immigrants",
			"https://investigate.info/company/transunion",
			0,
			1,
			0,
			0
		],
		"0C00000CS9": [
			"Tyson Foods",
			"One of the largest food manufacturing companies in the world. It uses incarcerated labor at its factories and has prison labor in its supply chain.",
			"Prison Labor",
			"https://investigate.info/company/tyson-foods",
			1,
			0,
			0,
			0
		],
		"0C000009J5": [
			"Virco Mfg",
			"A US-based manufacturer and supplier of educational furniture and equipment that uses prison labor.",
			"Prison Labor",
			"https://investigate.info/company/virco-manufacturing",
			1,
			0,
			0,
			0
		],
		"0C000009L0": [
			"Walmart",
			"The world's largest retailer. Uses prison labor in its supply chain.",
			"Prison Labor",
			"https://investigate.info/company/walmart",
			1,
			0,
			0,
			0
		],
		"0C00000CQI": [
			"Wendy's",
			"A US holding company that owns Wendy's, one of the world's largest fast-food chains. It uses incarcerated labor.",
			"Prison Labor",
			"https://investigate.info/company/wendys",
			1,
			0,
			0,
			0
		],
		"0C00000KZP": [
			"Western Union",
			"A US financial services company. Facilitates money trasfers to prisons.",
			"Banking and Financial Services",
			"https://investigate.info/company/geo-group",
			1,
			0,
			0,
			0
		],
		"0C00002BS7": [
			"Yamaha Motor",
			"A Japanese vehicle manufacturer that provides all-terrain vehicles and watercraft to US Border Patrol.",
			"Border Surveillance and Monitoring",
			"https://investigate.info/company/yamaha-motor",
			0,
			1,
			0,
			0
		],
		"0C000009RZ": [
			"Yum Brands",
			"One of the world's largest fast-food restaurant companies. Its subsidiary KFC uses prison labor.",
			"Prison Labor",
			"https://investigate.info/company/yum-brands",
			1,
			0,
			0,
			0
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/PffCompanyProfiles.json
// module id = 1007
// module chunks = 0